import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AlertService } from "ngx-alerts";
import { DashboardService } from "src/app/services/dashboard.service";

@Component({
  selector: "app-device-status-dialog",
  templateUrl: "./device-status-dialog.component.html",
  styleUrls: ["./device-status-dialog.component.scss"],
})
export class DeviceStatusDialogComponent implements OnInit {
  deviceStatusData = [];

  constructor(
    public dialogRef: MatDialogRef<DeviceStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string },
    private dashboardService: DashboardService,
    private alertService: AlertService
  ) {}

  toTitleCaseWithSpaces(str: string) {
    console.log(str)
    return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    });
  }
  ngOnInit(): void {
    console.log("data", this.data);
    console.log(this.data.userId);
    this.dashboardService.getUserMobileDeviceStatus(this.data.userId).subscribe(
      (res: any) => {
        for (let key in res.deviceStatus) {
          console.log(this.toTitleCaseWithSpaces(key));
          this.deviceStatusData.push({key: this.toTitleCaseWithSpaces(key), value: res.deviceStatus[key]});
        }
      },
      (error1) => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }
}
